import React from 'react'
import { Text, View } from 'react-native'
import { useThemeValue } from '../ThemeContext'
import { baseFont, HEADER_HEIGHT, legalParagraphStyle } from '../utils/ui'
import { Container, Reveal, Section } from '../components/ui'

export function LegalPage({
  title,
  updated,
  intro,
  sections,
}: {
  title: string
  updated: string
  intro: string
  sections: { title: string; body?: string[]; listLabel?: string; list?: string[] }[]
}) {
  const { theme } = useThemeValue()
  return (
    <Section background={theme.colors.background} paddingTop={HEADER_HEIGHT + 52} paddingBottom={96}>
      <Container>
        <View style={{ maxWidth: 900, alignSelf: 'center' }}>
          <Reveal>
            <Text style={{ ...baseFont('700'), color: theme.colors.text, fontSize: 48, lineHeight: 56, letterSpacing: -2, marginBottom: 24 }}>{title}</Text>
            <Text style={{ ...baseFont('500'), color: theme.colors.inactive, fontSize: 14, marginBottom: 40 }}>{updated}</Text>
            <Text style={{ ...baseFont('500'), color: theme.colors.text, fontSize: 18, lineHeight: 30, marginBottom: 36 }}>{intro}</Text>
          </Reveal>

          <View style={{ gap: 36 }}>
            {sections.map(section => (
              <View key={section.title} style={{ gap: 14 }}>
                <Text style={{ ...baseFont('700'), color: theme.colors.text, fontSize: 20 }}>{section.title}</Text>
                {section.body?.map(paragraph => (
                  <Text key={paragraph} style={{ ...baseFont('500'), color: theme.colors.inactive, ...legalParagraphStyle }}>
                    {paragraph}
                  </Text>
                ))}
                {section.listLabel ? (
                  <Text
                    style={{
                      ...baseFont('700'),
                      color: theme.colors.text,
                      fontSize: 12,
                      textTransform: 'uppercase',
                      letterSpacing: 1,
                    }}
                  >
                    {section.listLabel}
                  </Text>
                ) : null}
                {section.list?.map(item => (
                  <Text key={item} style={{ ...baseFont('500'), color: theme.colors.inactive, ...legalParagraphStyle }}>
                    • {item}
                  </Text>
                ))}
              </View>
            ))}
          </View>
        </View>
      </Container>
    </Section>
  )
}
